{
    "UserNotificationBusyTime": "Recevez une notification lorsque votre équipe est occupée.",
    "UserNotificationMissedCalls": "Recevez une notification lorsqu'un certain nombre d'appels ont été manqués dans les 60 minutes.",
    "UserNotificationWeeklyInsightsReport": "Recevoir un rapport de performance hebdomadaire.",
    "UserNotificationUserNotLoggedIn7Days": "Recevez une notification lorsque vous ne vous êtes pas connecté pendant 7 jours.",
    "UserNotificationAvgAnswerTime": "Recevez une notification lorsque votre temps de réponse moyen dépasse un certain nombre de secondes par intervalles d'une demi-heure.",
    "UserNotificationUserNeverLoggedIn": "Recevez une notification lorsque vous ne vous connectez pas.",
    "NAME": "UserNotificationTypesHelp"
}